import React from "react"
import { AutoplayVideo } from "../VideoLink/AutoPlayVideo"
import { HeroHeader } from "../Components/FocusHeaders/FocusAirHeader"
import { ImgText } from "../Components/ImgText"
import { ImgTextRight } from "../Components/ImgTextRight"
import { ImgTextTwo } from "../Components/ImgTextTwo"
import { Advantages } from "../Components/AdvantagesCards"
import { Footer } from "../Components/Footer"
import { ContactForm } from "../Components/ContactForm"
import { ImgTextBlocks } from "../Components/ImgTextBlocks"

function useFeatureFlag(flag: string): boolean {
  const params = new URLSearchParams(window.location.search)
  const fromUrl = params.get(flag)

  if (fromUrl !== null) {
    sessionStorage.setItem(`flag_${flag}`, fromUrl)
  }

  return (sessionStorage.getItem(`flag_${flag}`) ?? fromUrl) === "true"
}

export function Home(): React.JSX.Element {
  const isFullSite = useFeatureFlag("fullsite")

  return (
    <div>
      <HeroHeader />

      {isFullSite && (
        <>
          <div
            style={{
              textAlign: "center",
              padding: "120px 24px 100px 24px",
              maxWidth: "1200px",
              margin: "0 auto",
            }}
          >
            <h1
              style={{
                fontSize: "clamp(1.5rem, 4vw, 2.5rem)",
                fontWeight: "700",
                margin: "0 0 16px 0",
                color: "#333",
              }}
            >
              Air quality impacts us <br /> everywhere
            </h1>
            <p
              style={{
                fontSize: "clamp(0.875rem, 1.5vw, 1rem)",
                color: "#666",
                margin: "0",
                maxWidth: "700px",
                marginLeft: "auto",
                marginRight: "auto",
                lineHeight: "1.6",
              }}
            >
              We build sensors for your company, where you can track patch and
              update whenever you want
            </p>
          </div>
          <ImgTextBlocks />
          <Advantages />
        </>
      )}

      <div style={{ paddingTop: "120px", paddingBottom: "120px" }}>
        <ContactForm />
      </div>
      <Footer />
    </div>
  )
}

const styles = {
  container: {
    padding: "20px",
    marginTop: "56px",
  } as React.CSSProperties,
}